import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import { Route, Switch } from 'react-router-dom';
import { applyMiddleware, createStore, compose, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { loadingBarMiddleware } from 'react-redux-loading-bar';
import createHistory from 'history/createBrowserHistory';
import logger from 'redux-logger';
import configure from 'common/Settings';
import login from './reducers/login';
import LoginContainer from './containers/LoginContainer';

import { Urls } from 'django_js_control/reverse';
import axios from 'axios';

require('reset.css');
require('front/fonts.less');
require('front/style.less');

configure();

// axios.get(window.app.settings.staticUrl + 'svg/control/symbol/svg/sprite.symbol.svg').then( (data) => {
axios.get('/static/svg/control/symbol/svg/sprite.symbol.svg').then( (data) => {
    var div = document.createElement('div');
    div.innerHTML = data.data;
    div.style.display = 'none';
    document.body.insertBefore(div, document.body.childNodes[0]);
});

const history = createHistory();

const middlewares = [
    thunkMiddleware,
    routerMiddleware(history),
    loadingBarMiddleware({
        promiseTypeSuffixes: ['REQUEST', 'SUCCESS', 'FAILURE']
    }),
    logger
];

const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;


const store = createStore(
    login,
    {...window.app.data},
    composeEnhancers(applyMiddleware(
        ...middlewares
    ))
);

render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Switch>
                <Route exact path={Urls['control:login:login']()} component={LoginContainer} />
                <Route exact path={Urls['control:login:login'](':action')} component={LoginContainer} />
                <Route exact path={Urls['control:login:action'](':action',':code')} component={LoginContainer} />
            </Switch>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'));



// WEBPACK FOOTER //
// ./assets/app/login/App.js